import React, { useMemo } from 'react';
import { Footer, Skeleton } from '@sato/components';
import { observer } from 'mobx-react-lite';

import { StaticContentfulEntry } from '@/contentful/contentful.constants';
import { useContentfulEntry } from '@/contentful/hooks/useContentful';
import { IOmaSatoFooter } from '@/contentful/types';

import { Link } from '@components/common/Link';
import { apartmentStore } from '@stores/apartmentStore';
import { contractStore } from '@stores/contractStore';
import { userStore } from '@stores/userStore';

import { parseFooterData } from './OmaSATOFooter.utils';

const useContentfulFooter = () => {
  const { data, isLoading, error } = useContentfulEntry<IOmaSatoFooter>(
    StaticContentfulEntry.FOOTER
  );

  return useMemo(() => {
    return {
      data: data
        ? parseFooterData(data, { contractStore, apartmentStore, userStore })
        : undefined,
      isLoading,
      error,
    };
    // update footer on contract change since link lists might contain conditional wrappers depending on contract store state
  }, [data, contractStore.selectedContract, apartmentStore.selectedApartment]);
};

export const OmaSATOFooter = observer(() => {
  const { data, isLoading } = useContentfulFooter();

  const cookieHandler = () => {
    return window.Cookiebot?.show();
  };

  if (isLoading) return <Skeleton className="h-[20vh] w-full" />;

  if (!data) return null;

  return (
    <Footer<typeof Link>
      {...data}
      variant="omaSATO"
      linkComponent={Link}
      onCookiesClick={cookieHandler}
    />
  );
});
